import { render } from "./assignOrganisation.vue?vue&type=template&id=0dfe6a92"
import script from "./assignOrganisation.vue?vue&type=script&lang=js"
export * from "./assignOrganisation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__